<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="7">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('material_info_search_tooltip') ||
                  '物料编号/物料中文名称/物料英文名称/生产线名称/厂商编码/工厂样品编号/货币单位搜索……'
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                    >{{ $l('INDEX.advanced_search') || '高级搜索' }}</b-button
                  >
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
            <b-button
              size="sm"
              class="ml-2"
              variant="outline-success"
              @click="
                add({
                  pageType: 'add',
                  params: {},
                })
              "
              v-if="allow('A')"
            >
              <b-icon-plus></b-icon-plus>
              {{ $l('INDEX.btn_add') || '新增' }}
            </b-button>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      v-el-dialog-drag
    >
      <el-form ref="form" :model="form" size="small" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="24">
            <el-row :gutter="10">
              <el-form-item :label="$l('form_label_materialCategory') || '物料分类'">
                <el-col :span="24">
                  <dict-cascader-category
                    v-model="form.materialCategory"
                    :placeholder="$l('form_placeholder_selectMaterialCategory') || '请选择物料分类'"
                    size="small"
                    clearable
                    filterable
                    :sync-codes="true"
                    @change="onCategoryChange"
                  ></dict-cascader-category>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('table_label_material_name_chinese_name') || '物料中文名称'
              "
            >
              <el-input
                v-model="form.materialName"
                :placeholder="
                  $l('pe_material_name_chinese_name') || '请输入物料中文名称'
                "
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_material_name_english') || '物料英文名称'"
            >
              <el-input
                v-model.trim="form.materialNameEn"
                :placeholder="
                  $l('table_label_pe_material_name_english') ||
                    '请输入物料英文名称'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('table_label_manufacturer') || '物料供应商'">
              <dict-select
              :placeholder="
                $l('form_placeholder_selectSupplier') || '请选择物料供应商'
              "
              size="small"
              clearable
              filterable
              v-model="form.scmCode"
              :body="scmParams"
              url="/master/common/dict/scm"
            ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('table_label_customerMaterialNo') || '客户物料编号'"
            >
              <el-input
                v-model.trim="form.customerMaterialNo"
                :placeholder="
                  $l('table_label_pe_customerMaterialNo') || '请输入客户物料编号'
                "
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item :label="$l('form_label_selectCustomer') || '所属客户'">
              <dict-select
              :placeholder="$l('form_placeholder_selectCustomer') || '请选择所属客户'"
              size="small"
              clearable
              filterable
              v-model="form.custCodeList"
              :body="custParams"
              multiple
              url="/master/common/dict/customerSelect"
            ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('form_label_selectBrand') || '品牌'"
            >
            <dict-select
              clearable
              v-model="form.brandCodeList"
              filterable
              multiple
              url="/master/common/dict/brandSelect"
              :placeholder="$l('form_placeholder_selectBrand') || '请选择品牌'"
              style="width:100%"
            ></dict-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_label_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('form_label_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$l('form_label_status') || '有效状态'">
              <el-checkbox-group v-model="form.materialStatusList" size="small">
                <el-checkbox label="Y">
                  {{ $l('INDEX.form_label_valid') || '有效' }}
                </el-checkbox>
                <el-checkbox label="N">
                  {{ $l('INDEX.form_label_invalid') || '无效' }}
                </el-checkbox>
              </el-checkbox-group>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = {
  keyword: '',
  materialStatusList: ['Y'],
  materialCategory: '',
  mainMaterialCategoryCode: '',
  detailMaterialCategoryCode: '',
  scmCode: '',
  moqUnit: '',
  currencyUnit: '',
}
import DictCascaderCategory from '../dict-cascader-category/index.vue'

export default {
  components: {
    DictCascaderCategory
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      scmParams: {},
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      custParams: {},
      brandParams: {},
    }
  },
  created() {
    this.query()
  },
  methods: {
    add({ pageType, params = {} }) {
      //路由到添加
      this.$router.push({
        name: 'material-materialInfoSet-detail',
        params: { ...params, pageType },
      })
    },
    fromLoad(val) {
      this.$emit(val)
    },
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      this.$emit('query', this.form)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    // 物料分类变化时同步mainMaterialCategoryCode和detailMaterialCategoryCode
    onCategoryChange(data) {
      this.form.mainMaterialCategoryCode = data.mainMaterialCategoryCode
      this.form.detailMaterialCategoryCode = data.detailMaterialCategoryCode
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
